import * as React from "react";
import Anchor from "@components/Anchor";

const StrapiAnchor: React.FC = (props: any) => {
    return <Anchor anchor_link={props.anchor_link} />
}

export default StrapiAnchor